/* tslint:disable */
/* eslint-disable */
/**
 * BFF Web Product
 * API reference used to call the backend from the web frontend
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @interface UpsellSettingsDto
 */
export interface UpsellSettingsDto {
    /**
     * 
     * @type {string}
     * @memberof UpsellSettingsDto
     */
    'productId': string;
    /**
     * 
     * @type {string}
     * @memberof UpsellSettingsDto
     */
    'offerId': string;
    /**
     * 
     * @type {string}
     * @memberof UpsellSettingsDto
     */
    'redirectType': UpsellSettingsDtoRedirectTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof UpsellSettingsDto
     */
    'youtubeEmbedUrl'?: string;
}

/**
    * @export
    * @enum {string}
    */
export enum UpsellSettingsDtoRedirectTypeEnum {
    USER_GROUPS = 'user_groups',
    MEMBERS_AREA = 'members_area',
    EXTERNAL_URL = 'external_url',
    UPSELL = 'upsell'
}


